import { NgModule } from '@angular/core';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '@env/environment';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: environment.adfs.authority,

        redirectUrl: environment.adfs.callbackUri,
        postLogoutRedirectUri: environment.adfs.logoutUri,

        clientId: environment.adfs.clientId,
        scope: environment.adfs.scope,
        responseType: 'code',

        logLevel: LogLevel.Warn,
        silentRenew: false,
        // useRefreshToken: true,

        customParamsAuthRequest: {
          // prompt: 'select_account',
        },
        customParamsEndSessionRequest: {
          client_id: environment.adfs.clientId,
          logout_uri: environment.adfs.logoutUri, 
        },
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthOidcModule {}
